export const supportPhoneNumber = '(402) 999-4604';
export const supportPhoneNumberTollFree = '1 (877) 857-5080';
export const supportEmailAddress = 'support@mycynchealth.org';
export const notificationDuration = 8000;
export const HIGH = 'HIGH';
export const LOW = 'LOW';
